import React from "react";
import Checkbox from "./checkbox";
import { removeLastOccurrance } from "../utils/arrayUtils";

import "./multipleChoice.css";

interface MultipleChoiceProps {
    options: string[];
    active: string[];
    allowMultiple: boolean;
    onChange: (selected: string[]) => void;
}

export default function MultipleChoice(props: MultipleChoiceProps) {
    return <ul className="multiple-choice">
        {props.options.map((e, i) => {
            return <Checkbox value={props.active.includes(e)} label={e} onClick={(v: boolean) => {
                if(!props.allowMultiple) {
                    if(v) {
                        props.onChange([e]);
                    }else {
                        props.onChange([]);
                    }

                }else {

                    if(v) {
                        props.onChange([...props.active, e]);
                    }else {
                        props.onChange(removeLastOccurrance(props.active, e));
                    }
                }
            }}/>;
        })}
    </ul>
}